import Glide from '@glidejs/glide';
import Sizes from './glide_fixed_width_slides';

const defaultOptions = {
  gap: 30,
  slideWidth: 190,
  peek: 15,
  rewind: false,
};

export function initializeCardSlider(
  cardSliderSelector,
  options = defaultOptions,
  callback,
) {
  const cardSliderEl = document.querySelector(cardSliderSelector);

  if (cardSliderEl) {
    const cardSlider = new Glide(cardSliderSelector, options);
    if (callback) {
      callback(cardSlider, Sizes);
    } else {
      cardSlider.mount({
        Sizes,
      });
    }
  }
}
